import 'magnific-popup'

if ($('.js-btn-video').length || $('.js-btn-video-outer a[href*="youtu"]').length || $('.js-btn-video-outer a[href*="vimeo"]').length) {
  $('.js-btn-video, .js-btn-video-outer a[href*="youtu"], .js-btn-video-outer a[href*="vimeo"]').magnificPopup({
    disableOn: 767,
    type: 'iframe',
    mainClass: 'mfp-fade popup-video',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  })
}
